import { render, staticRenderFns } from "./About.vue?vue&type=template&id=4c8fc01c&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=4c8fc01c&prod&lang=scss&scoped=true"
import style1 from "./About.vue?vue&type=style&index=1&id=4c8fc01c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fc01c",
  null
  
)

export default component.exports